import { render, staticRenderFns } from "./NavigationMenuPromoGroupMobileItem.vue?vue&type=template&id=29794d32"
import script from "./NavigationMenuPromoGroupMobileItem.vue?vue&type=script&lang=js"
export * from "./NavigationMenuPromoGroupMobileItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuPromoGroupMobileItem.vue?vue&type=style&index=0&id=29794d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports